// Cache sur le poste (IndexedDB, store "cachedata") des données du tableau de bord (/tableaudebord).
// Une donnée de moins de 5 min est servie sans appeler le serveur ; au-delà elle est supprimée
// et l'onglet recharge depuis le serveur. Le bouton Actualiser passe { force: true } pour ignorer le cache.
// L'heure d'enregistrement est portée dans la valeur ({ t, data }) : les 24 h de saveOrUpdateData
// ne servent qu'au nettoyage général de cachedata.
import { getData, saveOrUpdateData, deleteData } from "@/service/indexedDBService";

export const TTL_TB = 5 * 60 * 1000;

// state.appsociete est un JWT regénéré à chaque chargement de page (son champ iat change) :
// la clé utilise le champ « token » de sa charge utile, stable, sinon le cache n'était jamais
// retrouvé après un rechargement.
function societeStable(societe) {
    try {
        const charge = String(societe).split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
        const json = JSON.parse(atob(charge + "=".repeat((4 - (charge.length % 4)) % 4)));
        return json.token || societe;
    } catch (e) {
        return societe;
    }
}

function cleTB(societe, onglet, params) {
    return `tb_${onglet}_${societeStable(societe)}_${JSON.stringify(params || {})}`;
}

// Renvoie { data, t } si la donnée est encore valable, sinon null.
export async function lireCacheTB(societe, onglet, params) {
    if (!societe) return null;
    const cle = cleTB(societe, onglet, params);
    try {
        const ligne = await getData("cachedata", cle);
        if (!ligne || typeof ligne.t !== "number" || ligne.data === undefined) return null;
        if (Date.now() - ligne.t > TTL_TB) {
            await deleteData("cachedata", cle);
            return null;
        }
        return ligne;
    } catch (error) {
        console.error('Error reading dashboard cache:', error);
        return null;
    }
}

export async function ecrireCacheTB(societe, onglet, params, data) {
    if (!societe || data === undefined || data === null) return;
    try {
        await saveOrUpdateData("cachedata", cleTB(societe, onglet, params), { t: Date.now(), data });
    } catch (error) {
        console.error('Error saving dashboard cache:', error);
    }
}

// Lit le cache, sinon appelle charger() (qui renvoie la donnée serveur, ou null en cas d'échec) et l'enregistre.
export async function avecCacheTB(societe, onglet, params, charger, { force = false } = {}) {
    if (!force) {
        const ligne = await lireCacheTB(societe, onglet, params);
        if (ligne) return { data: ligne.data, t: ligne.t, cache: true };
    }
    const data = await charger();
    if (data !== undefined && data !== null) await ecrireCacheTB(societe, onglet, params, data);
    return { data, t: Date.now(), cache: false };
}
